/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  GET_VIDEO_DETAILS,
  GET_VIDEO_DETAILS_SUCCESS,
  GET_VIDEO_DETAILS_FAIL,
  SEND_SURVEY_ANSWER,
  SEND_SURVEY_ANSWER_SUCCESS,
  SEND_SURVEY_ANSWER_FAIL,
} from './redux';
import Request from 'app/utils/xhrWrapper';

export function* getVideoDetails() {
  yield takeEvery(GET_VIDEO_DETAILS, function* ({ data }) : any {
    try {
      const response = yield Request.get(`partner/TV/watch/uid/${data}`);
      const responseData = _.get(response, ['data']);
      if (responseData) {
        yield put({ type: GET_VIDEO_DETAILS_SUCCESS, data: responseData });
      } else {
        yield put({ type: GET_VIDEO_DETAILS_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_VIDEO_DETAILS_FAIL, data: error });
    }
  });
}

export function* sendSurveyAnswer() {
  yield takeEvery(SEND_SURVEY_ANSWER, function* ({ data: { url, msg, id } }) : any {
    try {
      const response = yield Request.get(url);
      const submitSuccessfully = _.get(response, ['status']) === 200;
      if (submitSuccessfully) {
        yield put({ type: SEND_SURVEY_ANSWER_SUCCESS, data: { msg, id } });
      } else {
        yield put({ type: SEND_SURVEY_ANSWER_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: SEND_SURVEY_ANSWER_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getVideoDetails),
    fork(sendSurveyAnswer),
  ]);
}
